import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    fetchSingleRecordSuccess,
    resetState,
    searchClubs,
    searchClubsSuccess,
    searchClubsFail,
    vatCheck,
    vatCheckSuccess,
    searchCompanyProfileSuccess,
    fetchClubMembersSuccess,
    getPayment,
    getPaymentSuccess,
    getPaymentFailure,
    getCollectMaster,
    getCollectMasterSuccess,
    getCollectMasterFailure,
    connectCollectMaster,
    connectCollectMasterSuccess,
    connectCollectMasterFailure,
    disconnectCollectMaster,
    disconnectCollectMasterSuccess,
    disconnectCollectMasterFailure,
} from './clubs.action';
import { Category, Club, ClubSearch, CompanyData } from './clubs.model';
import { Member } from '../Member/member.model';

export interface ClubRecordsState {
    listData: any[];
    singleData: Club;
    loading: boolean;
    isVatValid: boolean;
    error: any;
    clubItems: any[];
    activity_loading: boolean;
    activity_error: any;
    countryList: any[];
    total: number;
    vatValue: string;
    clubSearch: string;
    companyData: CompanyData;
    clubMembers: Member[];
    categories: Category[];
    hasConnect: boolean|null;
    hasCollectMaster: boolean|null;
    paymentLoading: boolean;
    collectMasterLoading: boolean;
}

export const initialState: ClubRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    isVatValid: false,
    error: null,
    clubItems: [],
    activity_loading: false,
    activity_error: null,
    countryList: [],
    total: 0,
    vatValue: "",
    clubSearch: "",
    companyData: null,
    clubMembers: [],
    categories: [],
    hasConnect: null,
    hasCollectMaster: null,
    paymentLoading: false,
    collectMasterLoading: false,
};


export const clubRecordReducer = createReducer(
    initialState,

    //Fetch All
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total, isVatValid }) => {
        return { ...state, listData, total, isVatValid, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    //Single Record
    on(fetchSingleRecordSuccess, (state, { singleData, countryList, categories }) => {
        return { ...state, singleData, vatValue: singleData?.vat_number, countryList, categories, error: null };
    }),

    
    //Club Search
    on(searchClubsSuccess, (state, { clubItems, clubSearch }) => {
        return { ...state, clubItems, clubSearch, loading: false };
    }),

    //VAT CHeck
    on(vatCheckSuccess, (state, { isVatValid, vatValue }) => {
        return { ...state, isVatValid, vatValue, loading: false };
    }),

    //Company Profile Search
    on(searchCompanyProfileSuccess, (state, { companyData }) => {
        return { ...state, companyData, loading: false };
    }),
    
    //Club Members Fetched
    on(fetchClubMembersSuccess, (state, { clubMembers }) => {
        return { ...state, clubMembers };
    }),


    //GET PAYMENT
    on(getPayment, (state) => {
        return { ...state, paymentLoading: true, hasConnect: null, error: null };
    }),
    on(getPaymentSuccess, (state, {hasConnect}) => {
        return { ...state, paymentLoading: false, hasConnect, error: null };
    }),
    on(getPaymentFailure, (state, { error }) => {
        return { ...state, error, paymentLoading: false };
    }),

     //GET COLLECT MASTER
    on(getCollectMaster, (state) => {
        return { ...state, hasCollectMaster: null, error: null };
    }),
    on(getCollectMasterSuccess, (state, {hasCollectMaster}) => {
        return { ...state, hasCollectMaster, error: null };
    }),
    on(getCollectMasterFailure, (state, { error }) => {
        return { ...state, error };
    }),


    //GET COLLECT MASTER
    on(getCollectMaster, (state) => {
        return { ...state, collectMasterLoading: true, hasCollectMaster: null, error: null };
    }),
    on(getCollectMasterSuccess, (state, {hasCollectMaster}) => {
        return { ...state, collectMasterLoading: false, hasCollectMaster, error: null };
    }),
    on(getCollectMasterFailure, (state, { error }) => {
        return { ...state, error, collectMasterLoading: false };
    }),

    //CONNECTION REQUEST COLLECT MASTER
    on(connectCollectMaster, (state) => {
        return { ...state, collectMasterLoading: true, error: null };
    }),
    on(connectCollectMasterSuccess, (state) => {
        return { ...state, collectMasterLoading: false, error: null };
    }),
    on(connectCollectMasterFailure, (state, { error }) => {
        return { ...state, error, collectMasterLoading: false };
    }),

    //DISCONNECT REQUEST COLLECT MASTER
    on(disconnectCollectMaster, (state) => {
        return { ...state, collectMasterLoading: true, error: null };
    }),
    on(disconnectCollectMasterSuccess, (state) => {
        return { ...state, collectMasterLoading: false, error: null };
    }),
    on(disconnectCollectMasterFailure, (state, { error }) => {
        return { ...state, error, collectMasterLoading: false };
    }),


    
    //Reset State
    on(resetState, () => initialState)  // Reset action handler
);